import React, { useState } from "react";
import AddToCart from "../../../hooks/cart/AddToCart";
import { Collection, Product } from "../../../interfaces/interfaces";
import logo from "../../../assets/images/mariposaEB_logo_no_background.png";
import {useTranslation} from "react-i18next";

const Gallery = ({ props }: { props: { photos_collection: Collection; gallery_images_height: number } }) => {
    const [fullscreenImg, setFullscreenImg] = useState<string | null>(null);
    const products = props.photos_collection.products;
    const {t} = useTranslation()

    const handleClick = (imgUrl: string) => {
        setFullscreenImg(fullscreenImg === imgUrl ? null : imgUrl);
    };

    return (
        <div className="gallery-container">
            <div className="gallery-grid">
                {products.map((product: Product) => (
                    <div key={product.id} className="product-card">
                        <img
                            onClick={() => handleClick(product.imageUrl ? product.imageUrl : logo)}
                            src={product.imageUrl ? product.imageUrl : logo}
                            height={props.gallery_images_height}
                            alt={product.name}
                        />
                        <p>{product.name}</p>
                        <p>{product.price} €</p>
                        {product.sold ?
                            (<p>{t('cart.sold')}</p>) :
                            (<AddToCart
                            collectionKey={props.photos_collection.name}
                            product={product}
                                />
                            )}
                    </div>
                ))}
            </div>

            {fullscreenImg && (
                <div className="fullscreen-overlay" onClick={() => setFullscreenImg(null)}>
                    <img src={fullscreenImg} alt="fullscreen" />
                </div>
            )}
        </div>
    );
};

export default Gallery;
